//var $ = require("../../lib/jquery-1.11.2.mod.js");
var configModule = require("../../define/config.js");
var console = require("../../lib/logger.js");
var logFunctionStore = require("../../lib/logfunctionstore.js");
var logUtil = require("../../lib/logutil.js");
var Util = require("../../lib/util.js");
var FrameProxy = require("../../lib/frameproxy.js");
var Handshake = require("../../helper/handshake.js");
var EngineHelper = require("../../helper/enginehelper.js");
var SecureFrameProxy = require("../../lib/secureframeproxy.js");
var EventUtil = require("../../lib/eventutil.js");



//=================================
// setup
//
var myFrameId = Util.generateId();
var mySenderId = "Message.Frame." + myFrameId;
var myDecKey = Util.randomBytes(64, true);

/*global __GLOBAL_LOG_PREFIX__:true*/
if (__GLOBAL_LOG_PREFIX__ != null) {

    __GLOBAL_LOG_PREFIX__ += "[Frame." + myFrameId + "]";
}

console.info(__GLOBAL_LOG_PREFIX__, "^^^^^^^^^scout.frame.js start.^^^^^^^");

// topFrameProxy setup
var topFrameProxy = new FrameProxy();
topFrameProxy.setSenderId(mySenderId);
var targetInfo = topFrameProxy.getTargetInfo();
targetInfo.targetId = "Message.TopFrame";
targetInfo.window = window.top;
targetInfo.origin = "*";
topFrameProxy.setTargetInfo(targetInfo);
console.info(__GLOBAL_LOG_PREFIX__, "topFrameProxy init done.");

//extensionFrameProxy setup
var extensionFrameProxy = new SecureFrameProxy();
extensionFrameProxy.setSenderId(mySenderId);
console.info(__GLOBAL_LOG_PREFIX__, "extensionFrameProxy init done.");

// DPLogger setup
(function () {

    function relayLogFunction (logFunctionName, args) {

        logFunctionStore.applyLogFunctions("SilentLogger", console);

        extensionFrameProxy.postMessage("LogMessage", {
            level: logFunctionName,
            message: logUtil.stringifyLogArguments(args),
            time: new Date().getTime()
        });

        logFunctionStore.applyLogFunctions("DPLogger", console);
    }

    var dpRelayLogger = logUtil.createRelayLogger(relayLogFunction);

    logFunctionStore.storeLogFunctions("DPLogger", dpRelayLogger);

})();
console.info(__GLOBAL_LOG_PREFIX__, "DPLogger setup done.");

//engineHelper setup
var engineHelper = new EngineHelper();
console.info(__GLOBAL_LOG_PREFIX__, "engineHelper init done.");

//=================================
// message processing
//
// 1. handle engine events
engineHelper.setCallbackHandler(function (event) {

    console.info(__GLOBAL_LOG_PREFIX__, "[Frame] engine callback!");

    // make the first char upper cased, probeReturn -> ProbeReturn
    var messageId = event.cmd;
    messageId = messageId.charAt(0).toUpperCase() + messageId.slice(1);

    var isAuthNeeded = false;

    switch (messageId) {

        case "ProbeReturn":
            // target: malicious iframe
            // could be removed once Message Target Origin Validation is done
        case "StoreData":
        case "ReplayNext":
            // target: malicious iframe
            // could be removed once Message Sender Origin Validation is done
        case "QueryAndAutoFill":
            // could be removed once Form Filling Comfirmation UI or Formfilling Pop-out Frame is done
            isAuthNeeded = true;
            break;
        default:
            isAuthNeeded = false;
            break;
    }
    
    if (isAuthNeeded === true) {

        extensionFrameProxy.postSecureMessage(messageId, event.arg);

    } else {

        extensionFrameProxy.postMessage(messageId, event.arg);
    }
    
});

extensionFrameProxy.oneMessage("Probe", function (messageObj, messageProxy) {
    console.log(__GLOBAL_LOG_PREFIX__, "[Frame] Probe recieved!");

    var message = messageObj.message;
    var script = message.script;

    if (configModule.SHOW_EVAL === true) {

        script += "\n//# sourceURL=" + configModule.DEBUG_BASEURL + "/eval/probe." + message.id + ".Frame." + myFrameId + ".js";
    }

    engineHelper.evaluateScript(script);
});

extensionFrameProxy.oneMessage("Replay", function (messageObj, messageProxy) {
    console.log(__GLOBAL_LOG_PREFIX__, "[Frame] Replay recieved!");

    var message = messageObj.message;
    var script = message.script;

    if (configModule.SHOW_EVAL === true) {

        script += "\n//# sourceURL=" + configModule.DEBUG_BASEURL + "/eval/replay." + message.id + ".Frame." + myFrameId + ".js";
    }

    engineHelper.evaluateScript(script);
});

extensionFrameProxy.onMessage("FormFilling", function (messageObj, messageProxy) {
    console.log(__GLOBAL_LOG_PREFIX__, "[Frame] FormFilling recieved!");

    var message = messageObj.message;
    var script = message.script;

    if (configModule.SHOW_EVAL === true) {

        script += "\n//# sourceURL=" + configModule.DEBUG_BASEURL + "/eval/formfilling." + message.id + ".Frame." + myFrameId + ".js";
    }

    engineHelper.evaluateScript(script);
});

// Handling logger
extensionFrameProxy.onMessage("LoggerSettings", function (messageObj, messageProxy) {
    console.info(__GLOBAL_LOG_PREFIX__, "[LoggerSettings] Logger settings recieved!!");

    //1. Set logger for this frame
    logFunctionStore.applyLogFunctions(messageObj.message.loggerName, console);
});

//===============================
// things to do when frame unload
//$(window).on("unload", function() {
EventUtil.onEvent(window, "unload", function() {
    // these messages may not go through all message handlers in the target frame on Chrome
    // might due to the revocation of current iframe
    console.info(__GLOBAL_LOG_PREFIX__, mySenderId + " is unloading");

    topFrameProxy.postMessage("FrameUnload");
    extensionFrameProxy.postSecureMessage("FrameUnload");
});



Handshake.frames.frame(topFrameProxy, extensionFrameProxy, myDecKey);
console.info(__GLOBAL_LOG_PREFIX__, "handshake: post FrameReady to topFrame and extFrame");